// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { Plus } from 'lucide-react';
import { useModal } from '@/stores/use-modal-store.ts';
import { useEffect, useState } from 'react';
import { UserPlan } from '@/models/user';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/auth-context/use-auth.ts';
import { API_BASE } from '@/config';

export const NavigationAction = () => {
  const { onOpen } = useModal();
  const { user } = useAuth();
  const [plan, setPlan] = useState(UserPlan.FREE);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      return;
    }
    fetch(`${API_BASE}/api/users/${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        setPlan(data.plan);
      })
      .catch((error) => {
        // TODO: translate
        toast.error(`[Navigation Action] Something went wrong: ${error}`);
      });
  }, [user]);

  return (
    <div>
      <button
        onClick={() =>
          plan == UserPlan.FREE ? navigate('/channels/@me/boost?msg=Для%20создания%20сервера%20требуется%20обновление%20подписки') : onOpen('createServer')
        }
        className="group flex items-center"
      >
        <div className="mx-3 flex size-[48px] items-center justify-center overflow-hidden rounded-[24px] bg-background transition-all hover:rotate-180 group-hover:rounded-[16px] group-hover:bg-black dark:bg-neutral-700">
          <Plus
            className="text-black transition hover:rotate-180 group-hover:text-white dark:text-white"
            size={25}
          />
        </div>
      </button>
    </div>
  );
};
